export default "__VITE_ASSET__COv$$0G9__"